import { render, staticRenderFns } from "./ChoXuLy.vue?vue&type=template&id=969ce18e&scoped=true"
import script from "./ChoXuLy.vue?vue&type=script&lang=js"
export * from "./ChoXuLy.vue?vue&type=script&lang=js"
import style0 from "./ChoXuLy.vue?vue&type=style&index=0&id=969ce18e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969ce18e",
  null
  
)

export default component.exports